import React from 'react'

import { CheckboxInput } from '../Input'

const TransactionChecklistForm = ({
  handleCheckboxClick,
  isChecked,
}: {
  handleCheckboxClick: () => void
  isChecked: boolean
}) => {
  return (
    <div className='flex gap-12'>
      <CheckboxInput
        labelText='I understand'
        name='acceptTransactionChecklistAgreement'
        checked={isChecked}
        disabled={isChecked}
        value={isChecked ? 'true' : 'false'}
        handleChange={handleCheckboxClick}
        dataTestId='transaction-checklist-understand-checkbox'
      />
    </div>
  )
}

export { TransactionChecklistForm }
